 import { CancelConfComponent } from './cancel-conf/cancel-conf.component';
  import { ComponentsModule } from '../../components';
  import { CommonModule } from '@angular/common';
  import { NgModule } from '@angular/core';
  import { Routes, RouterModule } from '@angular/router';

  const routes: Routes = [
      { path: '', component: CancelConfComponent }
  ];

  @NgModule({
      imports: [
          RouterModule.forChild(routes),
          CommonModule,
          ComponentsModule
      ],
      declarations: [
        CancelConfComponent,
      ],
      exports: [
          RouterModule,
          CancelConfComponent
      ]
  })
  export class CancelConfModule {
      constructor() {
      }
  }



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/cancel-conf/cancel-conf.module.ts